import { render, staticRenderFns } from "./MultiEditor.vue?vue&type=template&id=3982e3b1&scoped=true"
import script from "./MultiEditor.vue?vue&type=script&lang=js"
export * from "./MultiEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982e3b1",
  null
  
)

export default component.exports